import { cpf } from '@solfacil/frontend-utils'
import { useField } from 'vee-validate'
import * as zod from 'zod'

export function useCpfValidation(t: (key: string) => string) {
  const cpfSchema = zod.string({ message: t('form.required') })
    .min(1, t('form.required'))
    .refine(val => cpf.validInput(val), { message: t('form.invalid_cpf') })

  function validateCpf(value: string) {
    const result = cpfSchema.safeParse(value)
    return result.success ? true : result.error.errors[0].message
  }

  return useField('cpfGuarantor', validateCpf)
}
